import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState,
    SettingControlType,
} from '@appblocks/codegeneration/types';

import BaseFeature from '@appblocks/codegeneration/BaseFeature';

export default class DisplayScreen extends BaseFeature {
    constructor() {
        super();
        this.name = 'Screen';
        this.id = 'display_screen';
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                min: 1,
                default: 'Screen',
            },
            {
                id: 'BACKCOLOR',
                name: 'Background Color',
                settingType: SettingType.COLOR,
                required: true,
                default: '#000000',
            },
            {
                id: 'WIDGETS',
                name: 'LCD Widgets',
                settingType: SettingType.ARRAY,
                required: true,
                controlType: SettingControlType.WIDGETS,
                default: new Array<BaseFeature>(0),
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getName(): string {
        return `${this.getSettingValue('NAME')}`;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: Array<CodeBlock> = [];
        const NAME = this.getSettingValue('NAME');

        if (this.project.runtime === 'simulator') {
            const WIDGETS = this.getSettingValue('WIDGETS');
            let widgetsTemplate = '';
            for (let i = 0; i < WIDGETS.length; i++) {
                const widget = WIDGETS[i];
                const widgetBlocks = widget.getCodeBlocks();
                blocks.push(...widgetBlocks);
                widgetsTemplate += `
"${widget.getID()}",
                `;
            }

            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `
this.updateContext("${this.getID()}", {
    WIDGETS: [
        ${widgetsTemplate}
    ]
})
`,
            });
        }
        return blocks;
    }
}
